import { render, staticRenderFns } from "./Iframe.vue?vue&type=template&id=58b6589a&scoped=true&"
import script from "./Iframe.vue?vue&type=script&lang=ts&"
export * from "./Iframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b6589a",
  null
  
)

export default component.exports